namespace Controlli {

    export namespace Confirm {
        let _box;
        let _message;
        let _localOptions: ConfirmOptions;
        let IsOpen: boolean;

        export function Initialize() {
            //get object
            _box = $("[data-myalert-box]");
            _message = $("[data-myalert-message]");

            $("[data-myalert-yes]").on("click", (e: JQuery.Event) => {
                ActionYes_ItemClick(_localOptions)
                Overlay.Hide(false);
                Hide();
            });
            $("[data-myalert-no]").on("click", (e: JQuery.Event) => ActionNo_ItemClick(e));

            $(document).on("Overlay_HideEvent", (e: JQuery.Event) => ActionNo_ItemClick(e));
        }

        export function Load(_options: ConfirmOptions) {
            _localOptions = _options;
            _message.html(_options.Messaggio);
            Show();
        }
        export function Show() {
            IsOpen = true;

            Overlay.Show();
            _box.show(0, function () {
                _box.stop().fadeTo("fast", 1);
            });
        }
        export function Hide() {
            _box.stop().fadeTo("fast", 0, function () {
                _box.hide();
            });
        }

        export function ActionYes_ItemClick(modalOption: ConfirmOptions): void {
            let _return = Ajax.AjaxPostHTML(modalOption.Url, modalOption.UrlData);

            if (!modalOption.HasEmptyResult) {
                if (modalOption.TargetID != undefined && modalOption.TargetID != "") {
                    if (modalOption.ReplaceContent)
                        $(modalOption.TargetID).html(_return);
                    else
                        $(modalOption.TargetID).replaceWith(_return);

                    Utility.RefreshControl($(modalOption.TargetID));
                }
                else {
                    if (modalOption.ReplaceContent)
                        $(Utility.BodyName).replaceWith(_return);
                    else
                        $(Utility.BodyName).html(_return);

                    Utility.RefreshControl();
                }
            }

            if (typeof modalOption.OnCompleteFunction != "undefined")
                eval(modalOption.OnCompleteFunction);
        }
        function ActionNo_ItemClick(obj: JQuery.Event): void {
            obj.preventDefault();
            Overlay.Hide(false);
            Hide();
        }

        export class ConfirmOptions {
            Messaggio: string;
            Url: string;
            UrlData: any;
            OnCompleteFunction: string;
            ReplaceContent: boolean;
            TargetID: string;
            HasEmptyResult: boolean;
        }

    }

}
